import { getRentListRequest } from '../../../../services/network/search/rent';

class CommonRentSearchService {
    async getRentSearchList(data) {
        return await getRentListRequest(data);
    }
}

export const RentSearchService = new CommonRentSearchService();
